/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RootAliases {
  FORGOT_PW_FRAGMENT = 'forgot-pw-fragment',
  FORGOT_PW_ROUTE = 'forgot-pw-route',
  FRAGMENT_CHANGE_PW_USERNAME = 'fragment-change-pw-username',
  FRAGMENT_CONF_USER_NEW_PW = 'fragment-conf-user-new-pw',
  FRAGMENT_HOME = 'fragment-home',
  FRAGMENT_NEW_USER_CONFIRMATION = 'fragment-new-user-confirmation',
  FRAGMENT_REDIRECT = 'fragment-redirect',
  FRAGMENT_TERMS_OF_USE = 'fragment-terms-of-use',
  INACTIVITY_FRAGMENT = 'inactivity-fragment',
  INACTIVITY_ROUTE = 'inactivity-route',
  LAYOUT_ROOT = 'layout-root',
  LOGIN_FRAGMENT = 'login-fragment',
  LOGIN_ROUTE = 'login-route',
  NEW_PW_FRAGMENT = 'new-pw-fragment',
  NEW_PW_ROUTE = 'new-pw-route',
  PRIVACY_WARNING_FRAGMENT = 'privacy-warning-fragment',
  PRIVACY_WARNING_ROUTE = 'privacy-warning-route',
  ROUTE_CHANGE_PW_USERNAME = 'route-change-pw-username',
  ROUTE_CONF_USER_NEW_PW = 'route-conf-user-new-pw',
  ROUTE_HOME = 'route-home',
  ROUTE_NEW_USER_CONFIRMATION = 'route-new-user-confirmation',
  ROUTE_REDIRECT = 'route-redirect',
  ROUTE_TERMS_OF_USE = 'route-terms-of-use',
}
export { RootAliases };
